module.exports = __webpack_public_path__ + "media/images/sk500-96781602b427a51fe3e1f15280290c01.svg";